import { Box, Modal } from '@mui/material';
import React from 'react';
import { ActionType } from '../components/ActionType';
import { BUTTON_VARIANTS } from '../constants/constants';
import I18n from '../i18n/I18n';
import FormModalBody from './FormModalBody';
import FormModalFooter from './FormModalFooter';
import FormModalHeader from './FormModalHeader';
import { FormModalProps } from './formUtils';

const FULL_HEIGHT_SX = { height: { xs: '100%', sm: '90%' } };

export default function FormModal({
    id,
    title,
    children,
    isOpen = false,
    width = '600px',
    isLoading = false,
    isSaving = false,
    isSaveDisabled = false,
    saveLabel = <I18n token="common.save" />,
    onSave = () => {},
    onClose = () => {},
    expanded = true,
    fullHeight = false,
    hideButtons = false,
    hideDefaultButtons = false,
    additionalLeftsideActions = [] as ActionType[],
    additionalActions = [] as ActionType[],
    loadingButtonVariant = BUTTON_VARIANTS.contained,
    sx = {},
    titleSx = {},
    modalBodySx = {},
    isReqFields = false,
    slots = undefined,
    slotProps = undefined,
    hideBackdrop = false,
    closeOnBackdropClick = false
}: FormModalProps) {
    return (
        isOpen && (
            <Modal
                open={isOpen}
                onClose={(_, reason) => {
                    if (reason !== 'backdropClick' || closeOnBackdropClick) {
                        onClose();
                    }
                }}
                id={id}
                slots={slots}
                slotProps={slotProps}
                hideBackdrop={hideBackdrop}
            >
                <Box
                    className="form-modal-container"
                    sx={{
                        position: 'absolute',
                        flexDirection: 'column',
                        width: { xs: '100%', sm: width },
                        height: expanded ? { xs: '100%', sm: '640px' } : 'initial',
                        maxHeight: { xs: '100%', sm: '90%' },
                        bgcolor: 'background.paper',
                        boxShadow: { xs: 0, sm: 24 },
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        display: 'flex',
                        boxSizing: 'border-box',
                        borderRadius: { xs: 0, sm: 1 },
                        zIndex: 10,
                        ...(fullHeight ? FULL_HEIGHT_SX : {}),
                        ...sx
                    }}
                >
                    <FormModalHeader title={title} onClose={onClose} sx={titleSx} />
                    <FormModalBody modalBodySx={modalBodySx} isLoading={isLoading} children={children} />
                    <FormModalFooter
                        hideFooter={hideButtons}
                        additionalLeftsideActions={additionalLeftsideActions}
                        additionalActions={additionalActions}
                        hideDefaultButtons={hideDefaultButtons}
                        isReqFields={isReqFields}
                        isSaveDisabled={isSaveDisabled}
                        isSaving={isSaving}
                        loadingButtonVariant={loadingButtonVariant}
                        onSave={onSave}
                        saveLabel={saveLabel}
                    />
                </Box>
            </Modal>
        )
    );
}
